define('plugin/additional-fields/model/AdditionalFieldModel',['require','lib/model/BaseModel','lib/validator/ValidatorNotEmpty','lib/validator/ValidatorDigitsOnly','Config'],function (require) {

    var BaseModel = require('lib/model/BaseModel');
    var ValidatorNotEmpty = require('lib/validator/ValidatorNotEmpty');
    var ValidatorDigitsOnly = require('lib/validator/ValidatorDigitsOnly');

    var Config = require('Config');

    /**
     * Additional field model
     *
     * @class AdditionalFieldModel
     */
    return BaseModel.extend({
        
        parent_id_field: 'sheduler_id',
        
        cloudFileInitiateUploadUrl: '/ext/cloud-storage/initiate-upload',
        cloudFileUploadChunkUrl:    '/ext/cloud-storage/upload-chunk',

        defaults: {
            id: '',
            name: '',
            title: '',
            type: '',
            values: [],
            default: null,
            is_null: false,
            value: null,
            error: false
        },

        initialize: function () {
            this.initValidators();

            this.updatePredefinedFieldInfo();

            this.listenTo(Config.getInstance(), 'config:changed', this.updatePredefinedFieldInfo);            

            BaseModel.prototype.initialize.call(this);
        },
        
        getDefault: function () {
            var predefined = Config.getInstance().getOption('predefined') || {};
            var name = this.get('name');
            if (predefined.fields && predefined.fields[name]) {
                return predefined.fields[name];
            }
            return this.get('default');
        },
        
        initValidators: function () {
            var validators = [];
            
            // if (this.get('type') === 'static') { //DEBUG
            //     return;
            // }
            
            if (!parseInt(this.get('is_null'))) {
                validators.push(new ValidatorNotEmpty());
            }
            if (this.get('type') === 'digits') {
                validators.push(new ValidatorDigitsOnly());
            }

            this.validators = {
                value: validators
            };
        },

        updatePredefinedFieldInfo: function () {
            //console.log('updatePredefinedFieldInfo');
            var predefined = Config.getInstance().getOption('predefined') || {};
            var name = this.get('name');
            if (predefined.fields && predefined.fields[name]) {
               // console.log('set default value', predefined.fields[name]);
                this.set('default', predefined.fields[name]);
            }
        },

        parse: function () {
            var data = BaseModel.prototype.parse.apply(this, arguments);
            if (data.type === 'checkbox' && data.default == '0') {
                data.default = '';
            }

            return data;
        },

        validate: function () {
            var result = BaseModel.prototype.validate.apply(this, arguments);
            var error = null;

            if (result && result.value) {
                error = result.value.shift();
            }

            this.set('error', error);

            return result;
        },
        
        uploadFile: function (file, parentId) {
            var _this = this;

            return new Promise(function (resolve, reject) {

                var maxSize = Config.getMaxCloudFileSize();
                if (file.size > maxSize) {
                    reject(['File size exceeds the ' + (maxSize / 1024 / 1024) + ' MB limit']);
                    return;
                }

                // Step 1: ask the server to open a Google Drive resumable upload session.
                // The server keeps the resumable URI; we get back an opaque token.
                var initiateForm = new FormData();
                initiateForm.append('filename',  file.name);
                initiateForm.append('mime_type', file.type || 'application/octet-stream');
                initiateForm.append('file_size', file.size);
                if (parentId) initiateForm.append(_this.parent_id_field, parentId);

                Backbone.ajax({
                    url:         _this.baseUrl + _this.cloudFileInitiateUploadUrl,
                    dataType:    'json',
                    cache:       false,
                    contentType: false,
                    processData: false,
                    data:        initiateForm,
                    type:        'POST',
                }).success(function (initData) {
                    if (!initData.success) {
                        reject(initData.errors);
                        return;
                    }

                    // Step 2: send the file in 1 MB chunks as raw binary POST bodies.
                    // This bypasses upload_max_filesize (which only applies to
                    // multipart/form-data uploads). post_max_size is the only limit.
                    var chunkSize = initData.chunk_size;

                    function sendChunk(offset) {
                        var chunk  = file.slice(offset, offset + chunkSize);
                        var params = '?upload_token=' + encodeURIComponent(initData.upload_token)
                                   + '&offset='      + offset
                                   + '&total_size='  + file.size;

                        Backbone.ajax({
                            url:         _this.baseUrl + _this.cloudFileUploadChunkUrl + params,
                            cache:       false,
                            contentType: 'application/octet-stream',
                            processData: false,
                            data:        chunk,
                            type:        'POST',
                            dataType:    'json',
                        }).success(function (data) {
                            if (data.status === 'done') {
                                resolve(data.hash);
                            } else if (data.status === 'pending') {
                                sendChunk(data.next_offset);
                            } else {
                                reject(data.errors || ['Upload failed']);
                            }
                        }).error(function (error) {
                            reject(error);
                        });
                    }

                    sendChunk(0);

                }).error(function (error) {
                    reject(error);
                });

            });
        }

    });

});
